import gql from 'graphql-tag';
export const PRODUCT = gql`
  fragment Product on Product {
    enabled
    id
    createdAt
    updatedAt
    languageCode
    name
    slug
    description
    channels {
      id
    }
    assets {
      id
      createdAt
      updatedAt
      name
      type
      fileSize
      mimeType
      width
      height
      source
      preview
    }
    featuredAsset {
      id
      createdAt
      updatedAt
      name
      type
      fileSize
      mimeType
      width
      height
      source
      preview
      focalPoint {
        x
        y
      }
    }
    variants {
      id
      name
      enabled
      price
      stockOnHand
      stockAllocated
      sku
      options {
        id
        name
      }
      featuredAsset {
        id
        preview
        focalPoint {
          x
          y
        }
      }
      product {
        id
        name
      }
    }
    optionGroups {
      id
    }
    facetValues {
      id
    }
    translations {
      id
    }
    collections {
      id
      name
      filters {
        code
        args {
          name
          value
        }
      }
    }
    customFields {
      subscriptionPlan {
        id
      }
      unit
      price
    }
  }
`;

export const PRODUCT_WITHOUT_COLLECTION = gql`
  fragment ProductWithoutCollection on Product {
    enabled
    id
    createdAt
    updatedAt
    languageCode
    name
    slug
    description
    channels {
      id
    }
    assets {
      id
      createdAt
      updatedAt
      name
      type
      fileSize
      mimeType
      width
      height
      source
      preview
    }
    featuredAsset {
      id
      createdAt
      updatedAt
      name
      type
      fileSize
      mimeType
      width
      height
      source
      preview
      focalPoint {
        x
        y
      }
    }
    variants {
      id
      name
      price
      stockOnHand
      stockAllocated
      sku
      featuredAsset {
        id
        preview
        focalPoint {
          x
          y
        }
      }
    }
    optionGroups {
      id
    }
    facetValues {
      id
    }
    translations {
      id
    }
    customFields {
      subscriptionPlan {
        id
      }
      unit
      price
    }
  }
`;

export const FACET_VALUE = gql`
  fragment FacetValue on FacetValue {
    id
    createdAt
    updatedAt
    languageCode
    facet {
      isPrivate
      id
      createdAt
      updatedAt
      name
      code
    }
    name
    code
  }
`;

export const PRODUCTS = gql`
  query newProducts(
    $options: ProductListOptions
    $sku: String
    $collectionId: ID
    $state: SalesStatus
    $isFilterPreSale: Boolean
  ) {
    newProducts(
      options: $options
      sku: $sku
      collectionId: $collectionId
      state: $state
      isFilterPreSale: $isFilterPreSale
    ) {
      totalItems
      items {
        ...Product
      }
    }
  }
  ${PRODUCT}
`;

export const FACET_VALUES = gql`
  query facetValues($options: FacetValueListOptions) {
    facetValues(options: $options) {
      totalItems
      items {
        ...FacetValue
      }
    }
  }
  ${FACET_VALUE}
`;

export const GET_CUSTOMER_PRODUCT_VARIANTS = gql`
  query GetProductVariantOptions($id: ID!) {
    product(id: $id) {
      id
      createdAt
      updatedAt
      name
      optionGroups {
        ...ProductOptionGroup
        options {
          ...ProductOption
          __typename
        }
        __typename
      }
      variants {
        id
        createdAt
        updatedAt
        enabled
        name
        sku
        price
        stockAllocated
        stockOnHand
        enabled
        options {
          id
          createdAt
          updatedAt
          name
          code
          groupId
          __typename
        }
        featuredAsset {
          id
          preview
          focalPoint {
            x
            y
          }
        }
        customFields {
          costPrice
          isShowBuyNow
          saleTag
        }
      }
      pointsExchangeInfo {
        id
        status
      }
    }
  }

  fragment ProductOptionGroup on ProductOptionGroup {
    id
    createdAt
    updatedAt
    code
    languageCode
    name
    translations {
      id
      languageCode
      name
      __typename
    }
    __typename
  }

  fragment ProductOption on ProductOption {
    id
    createdAt
    updatedAt
    code
    languageCode
    name
    groupId
    translations {
      id
      languageCode
      name
    }
    customFields {
      priority
    }
  }
`;

export const FAST_UPDATE_PRODUCT_VARIANT = gql`
  mutation updateProduct($input: UpdateProductInput!) {
    updateProduct(input: $input) {
      id
      variants {
        id
        name
        sku
        price
        stockOnHand
      }
      customFields {
        price
      }
    }
  }
`;

export const SYNC_PRODUCT_JOB = gql`
  mutation syncProductJob {
    syncProductJob
  }
`;

export const SYNC_PRODUCT = gql`
  mutation syncProduct($page: Int!, $pageSize: Int!, $title: String, $isDisplay: Boolean) {
    syncProduct(page: $page, pageSize: $pageSize, title: $title, isDisplay: $isDisplay)
  }
`;
